<template>
	<div class="ticker-wrap">
		<div class="ticker">
			<div class="ticker__item">
				Vendredi 15 novembre, un amendement pour avantager fiscalement les importations d'huile de palme de Total va être de nouveau soumis au vote. Il faut agir maintenant&nbsp;!
			</div>
		</div>
	</div>
</template>


<script>
export default {

}
</script>


